import { render, staticRenderFns } from "./iq-card.vue?vue&type=template&id=3d35d9c0&"
import script from "./iq-card.vue?vue&type=script&lang=js&"
export * from "./iq-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports